import React from 'react';
import { Box } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { useTranslate } from 'react-admin';
import { getNameWithoutPrefix } from '../../../utils/resources/MetadataAvatarType';
import { toFormatDate } from '../../../utils/date';
import CollapsePanel from '../components/CollapsePanel';
import InfoItem from './components/InfoItem';

interface DescriptionPanelProps {
    selected: any;
}

const DescriptionPanel: React.FC<DescriptionPanelProps> = ({ selected }) => {
    const t = useTranslate();

    const typeLabel = (() => {
        const name1 = selected?.metadataAvatarType?.name;
        const name2 = selected?.productTypeName;
        if (name1) return getNameWithoutPrefix(name1);
        if (name2) return getNameWithoutPrefix(name2);
        return '-';
    })();

    const createdDate = selected?.creationDate || selected?.productCreationDate;

    return (
        <CollapsePanel icon={<InfoIcon fontSize='small' />} title={t('app.objects.description') || 'Descripción'}>
            <Box
                style={{
                    display: 'grid',
                    gap: 8,
                }}
            >
                <InfoItem
                    label={t('app.objects.info.name') || 'Nombre'}
                    value={selected?.name || selected?.productName || '-'}
                />

                <InfoItem label={t('app.objects.info.type') || 'Tipo'} value={typeLabel} />

                <InfoItem
                    label={t('app.objects.info.description') || 'Descripción'}
                    value={selected?.description || selected?.productDescription || '-'}
                />

                <InfoItem
                    label={t('app.objects.info.reference')}
                    value={selected?.alphaId || selected?.productSerialNumber || '-'}
                />

                <InfoItem
                    label={t('app.objects.info.created') || 'Creado'}
                    value={createdDate ? toFormatDate(createdDate) : '-'}
                />
            </Box>
        </CollapsePanel>
    );
};

export default DescriptionPanel;
